
import { Injectable } from '@angular/core';
import { KitchenModel } from './model/kitchen.model';
// import { RequestData } from 'src/app/common/models/request-data.model';
import { RequestData } from '../../../../common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../src/environments/environment';

import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class KitchenService {


   constructor(private http: HttpClient) { }
  
    getList(requestData:RequestData): Observable<any> {
      return this.http.post(environment.baseUrl+'/shop/kitchen/get', requestData);
  
    }
  
    getById(id:number): Observable<any> {
      return this.http.post(environment.baseUrl+'/shop/kitchen/get/'+id, '');
  
    }
  
     /**
     * 
     * @param kitchenInfo 
     * Calls the update API to insert/update the record
     */
     update(kitchenInfo: KitchenModel): Observable<any> { 
      if(kitchenInfo.hasOwnProperty("id")){
        return this.http.post(environment.baseUrl+'/shop/kitchen/update', kitchenInfo);
      } else{
        return this.http.post(environment.baseUrl+'/shop/kitchen/add', kitchenInfo);
      }
    }
  
  
      /**
     * 
     * @param areaInfo 
     * Calls the API to delete the record
     */
      delete(areaInfo: KitchenModel): Observable<any>  {
        return this.http.post(environment.baseUrl+'/shop/kitchen/delete/'+areaInfo.id, areaInfo);
      }
  
      // downloadExcel(requestData: any): Observable<Blob> {
      //   const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      //  // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL
    
      //   return this.http.post(environment.baseUrl + '/hq/area/export-region-list', requestData, { headers, responseType: 'blob' })
      //     .pipe(
      //       //catchError(this.handleError)
      //     );
    
      // }
  
}
